import * as React from 'react';
import {
	Show,
	ShowProps,
	SimpleShowLayout,
	TextField,
	UrlField
} from 'react-admin';
import { TranslateField } from '../components/TranslateField';
import TimeField from "../components/TimeField";

export const LiveTrainingShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="title" label="TITLE"/>
				<TranslateField source="dayOfWeek" label="DAY"/>
				<TimeField source="startHour" label="START_HOUR"/>
				<TimeField source="endHour" label="END_HOUR"/>
				<UrlField source="link" label="LINK"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
